/**
 * @generated SignedSource<<a37dc95bde520dccc0f48434be3fe7b2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type Roles = "ADMIN" | "COWORKER_GROUP" | "CO_WORKER" | "MANAGER" | "READ_ONLY";
import { FragmentRefs } from "relay-runtime";
export type WhitelistUsersList_Store$data = {
  readonly users: ReadonlyArray<{
    readonly employee: {
      readonly id: string;
      readonly name: string;
      readonly " $fragmentSpreads": FragmentRefs<"Avatar_employee">;
    } | null;
    readonly id: string;
    readonly role: Roles;
    readonly user: {
      readonly id: string;
    };
    readonly " $fragmentSpreads": FragmentRefs<"StoreUserRoleAndEmailTag_storeUser">;
  }>;
  readonly " $fragmentType": "WhitelistUsersList_Store";
};
export type WhitelistUsersList_Store$key = {
  readonly " $data"?: WhitelistUsersList_Store$data;
  readonly " $fragmentSpreads": FragmentRefs<"WhitelistUsersList_Store">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WhitelistUsersList_Store",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "StoreUser",
      "kind": "LinkedField",
      "name": "users",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "role",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "StoreUserRoleAndEmailTag_storeUser"
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "User",
          "kind": "LinkedField",
          "name": "user",
          "plural": false,
          "selections": [
            (v0/*: any*/)
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Employee",
          "kind": "LinkedField",
          "name": "employee",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "Avatar_employee"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Store",
  "abstractKey": null
};
})();

(node as any).hash = "4bc7f771a2f2b141f8733bdbeebcfa8a";

export default node;
